import { StyledTag } from './StepTagStyles';

type ITagProps = {
  number?: number;
  status?: string;
};

const StepTag = ({ number, status }: ITagProps) => {
  return <StyledTag $status={status}>{number}</StyledTag>;
};

export default StepTag;
